var trackVerificationFeedback = function trackVerificationFeedback(pulseEvent, accountVerified) {
  try {
    pulseEvent({
      type: 'View',
      name: "BankId Verification feedback, ".concat(accountVerified ? 'account verified' : 'not verified'),
      object: {
        type: 'UIElement',
        id: "bankid_verification:".concat(accountVerified ? 'success' : 'failure')
      }
    });
  } catch (e) {
    console.log(e);
  }
};

export default trackVerificationFeedback;
//# sourceMappingURL=trackingFunc.js.map